import PropTypes from "prop-types";
import React, { useState } from "react";
import Form from "react-bootstrap/Form";
import { useDispatch } from "react-redux";
import {
  enableDisableEventTypeAction
} from "../../../store/actions/adminEventType";
import adminConstant from "../../../util/adminConstant";
import constant from "../../../util/constant";
import EventDisableModal from "./eventTypeDisableModal";

const { MODAL_TYPE_DETAIL } = adminConstant;
const { DEFAULT_UUID } = constant;

const ViewEventType = ( { eventTypeDetail, type } ) => {
  const dispatch = useDispatch();
  const [ isOpened, setIsOpened ] = useState( false );
  const [ modalData, setModalData ] = useState( false );
  const [ eventTypeData, setEventData ] = useState();

  const handleOpenModal = ( eventType ) => {
    setIsOpened( true );
    setModalData( eventType );
    setEventData( eventTypeDetail );
  };

  const handleCloseModal = () => {
    setIsOpened( false );
  };

  const handleConfirm = ( eventType ) => {
    if( ( eventType === MODAL_TYPE_DETAIL.ACTIVE_EVENT_TYPE.type ) ||
      ( eventType === MODAL_TYPE_DETAIL.INACTIVE_EVENT_TYPE.type ) ) {
      dispatch( enableDisableEventTypeAction(
        {
          eventTypeId: eventTypeDetail.eventTypeId, setEnabled: eventType === MODAL_TYPE_DETAIL.ACTIVE_EVENT_TYPE.type
            ? false
            : true } ) );
      setIsOpened( false );
    }
    else {
      setIsOpened( false );
    }
  };

  return (
    <>
      <div className='main-wrapper'>
        <div className='main-right-wrapper'>
          <div className='page-head-wrapper'>
            <h4 className='page-heading'>
              Event
            </h4>
            {( ( ( eventTypeDetail?.isActivePartner === true ) || ( eventTypeDetail?.partnerId === DEFAULT_UUID ) ) && ( type === "admin" ) && ( <div className='page-head-right'>
              <div className='btn-switch large'>
                <Form.Check
                  type='switch'
                  id='custom-switch'
                  label='Enabled'
                  checked={eventTypeDetail?.isActive || false}
                  onChange={() =>
                    handleOpenModal(
                      eventTypeDetail?.isActive
                        ? MODAL_TYPE_DETAIL.ACTIVE_EVENT_TYPE.type
                        : MODAL_TYPE_DETAIL.INACTIVE_EVENT_TYPE.type
                    )
                  }
                />
              </div>
            </div> ) )}
          </div>
          <div className='page-inner-box profile-steps-box'>
            <div className="content-section">
              <div className="content-label">Event Type ID</div>
              <div className="content-des">{eventTypeDetail.eventTypeId}</div>
            </div>
            <div className="content-section">
              <div className="content-label">Event Name</div>
              <div className="content-des">{eventTypeDetail.eventName}</div>
            </div>
            <div className="content-section">
              <div className="content-label">Units</div>
              <div className="content-des">{eventTypeDetail.unitName}</div>
            </div>
            { eventTypeDetail.partnerName && (
              <div className="content-section">
                <div className="content-label">Partner Name</div>
                <div className="content-des">{eventTypeDetail.partnerName}</div>
              </div>
            )}
            <div className="content-section">
              <div className="content-label">Description</div>
              <div className="content-des">{eventTypeDetail.description}</div>
            </div>
          </div>
        </div>
      </div>
      <EventDisableModal
        isOpened={isOpened}
        onClose={handleCloseModal}
        modalData={modalData}
        eventTypeData={eventTypeData}
        onConfirm={handleConfirm}
      />
    </>
  );
};

ViewEventType.propTypes = {
  eventTypeDetail: PropTypes.object,
  type: PropTypes.string,
};

export default ViewEventType;
